import { render, staticRenderFns } from "./TermsPop3.vue?vue&type=template&id=08724174&"
import script from "./TermsPop3.vue?vue&type=script&lang=ts&"
export * from "./TermsPop3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports